import React from "react";
import InvalidLinkLogo2 from "../../icons/InvalidLinkLogo2.svg";
import VectorTopRight from "../../icons/VectorTopRight.svg";
import VectorBottomLeft from "../../icons/VectorBottomLeft.svg";
import MMTCLOGO from "../../icons/MMTCLOGO.svg";

export const InvalidLinkScreen = ({
  title = "Invalid Link",
  description = "The link you selected has either expired or been used.",
  logo: Logo = InvalidLinkLogo2
}) => {
  return (
    <div className="flex w-full h-screen justify-center items-center bg-white relative overflow-hidden">
      {/* Background Vectors */}
      <div className="absolute top-0 right-0 z-0 pointer-events-none">
        <VectorTopRight />
      </div>
      <div className="absolute bottom-0 left-0 z-0 pointer-events-none">
        <VectorBottomLeft />
      </div>

      <div className="absolute top-[90px] w-full flex justify-center z-[1]">
        <MMTCLOGO />
      </div>

      <div className="w-[565px] p-10 flex flex-col items-center gap-[14px] rounded-[10px] bg-white z-[1] sm:w-[90%] sm:p-5">
        <div className="w-[141px] h-[141px] mb-[14px] flex justify-center items-center">
          <Logo />
        </div>
        <div className="font-['Open_Sans',_sans-serif] font-bold text-[20px] text-black text-center leading-[1.36]">
          {title}
        </div>
        <div className="font-['Open_Sans',_sans-serif] font-normal text-[16px] text-[#3C3C3C] text-center leading-[1.625] max-w-[561px]">
          {description}
          Please contact your Loan Officer if you need assistance.
        </div>
      </div>
    </div>
  );
};
